// Iter 374 — Datos de pago por proveedor antes de generar OCs desde el Cuadro Comparativo.
// Sin condición vigente (y Medio de Pago si es Contado/Tarjeta) la OC no se puede crear.
const RE_DIAS = /^\s*0*(\d+)\s*d[ií]as?\s*$/i;

export const resolverCondicionInicial = (prov, vigentes) => {
  const cod = (prov?.condicion_pago_codigo || '').trim();
  if (cod && vigentes.some((c) => c.codigo === cod)) return cod;
  const txt = (prov?.condicion_pago || '').trim();
  if (!txt) return '';
  const porNombre = vigentes.find((c) => c.nombre.toLowerCase() === txt.toLowerCase());
  if (porNombre) return porNombre.codigo;
  if (/^(de )?contado$/i.test(txt)) return vigentes.find((c) => c.tipo === 'contado')?.codigo || '';
  const m = RE_DIAS.exec(txt);
  if (m) return vigentes.find((c) => c.tipo === 'credito' && Number(c.dias_plazo) === Number(m[1]))?.codigo || '';
  return '';
};

export const requiereMedio = (cond) => cond && (cond.tipo === 'contado' || cond.tipo === 'tarjeta');

export const pagoIncompleto = (pago, vigentes) => {
  const cond = vigentes.find((c) => c.codigo === pago?.condicion_pago_codigo);
  if (!cond) return 'Falta condición de pago vigente';
  if (requiereMedio(cond) && !pago.medio_pago_codigo) return `La condición ${cond.nombre} exige Medio de Pago`;
  return '';
};

export const PagoProveedorSelector = ({ provIdx, pago, vigentes, medios, onChange }) => {
  const cond = vigentes.find((c) => c.codigo === pago?.condicion_pago_codigo);
  const esTarjeta = cond?.tipo === 'tarjeta';
  const mediosFiltrados = medios.filter((m) => ((m.categoria || 'otro') === 'tarjeta_credito') === esTarjeta);
  const error = pagoIncompleto(pago, vigentes);
  return (
    <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-2" data-testid={`pago-proveedor-${provIdx}`}>
      <div>
        <label className="block text-[11px] font-medium text-gray-600 mb-0.5">Condición de Pago <span className="text-red-600">*</span></label>
        <select
          value={pago?.condicion_pago_codigo || ''}
          onChange={(e) => onChange({ condicion_pago_codigo: e.target.value, medio_pago_codigo: '' })}
          className={`w-full h-8 px-2 rounded-md border text-xs bg-white ${!cond ? 'border-red-400 bg-red-50/40' : 'border-input'}`}
          data-testid={`select-condicion-prov-${provIdx}`}
        >
          <option value="">Seleccione…</option>
          {vigentes.map((c) => <option key={c.codigo} value={c.codigo}>{c.nombre}</option>)}
        </select>
      </div>
      {requiereMedio(cond) && (
        <div>
          <label className="block text-[11px] font-medium text-gray-600 mb-0.5">Medio de Pago <span className="text-red-600">*</span></label>
          <select
            value={pago?.medio_pago_codigo || ''}
            onChange={(e) => onChange({ ...pago, medio_pago_codigo: e.target.value })}
            className={`w-full h-8 px-2 rounded-md border text-xs bg-white ${!pago?.medio_pago_codigo ? 'border-red-400 bg-red-50/40' : 'border-input'}`}
            data-testid={`select-medio-prov-${provIdx}`}
          >
            <option value="">Seleccione medio de pago…</option>
            {mediosFiltrados.map((m) => <option key={m.codigo} value={m.codigo}>{m.nombre}</option>)}
          </select>
        </div>
      )}
      {error && <p className="md:col-span-2 text-[11px] text-red-700" data-testid={`pago-error-prov-${provIdx}`}>⛔ {error}</p>}
    </div>
  );
};
